import { useQuery } from "@apollo/client";
import {
	useEffect,
	useState,
} from "react";
import PublicAppVars from 'utils/PublicAppVars.js';
import { get } from 'lodash';

// Takes a paginated query and reruns it until all pages have been consumed
const Unpaginate = ({
	query,
	variables,
	totalCountSelector, // number of records server knows about
	dataSelector,
	children,
	pageSize = PublicAppVars.MAX_TRIPS_HISTORY_PAGE_SIZE,
	limit = 100000, // number of records (not pages)
}) => {
	const [ aggregation, setAggregation ] = useState([]);
	const [ offset, setOffset ] = useState(0);
	const [ done, setDone ] = useState(false);

	const pageResult = useQuery(query, {
		variables: {
			...variables,
			offset,
		},
	});

	useEffect(() => {
		if (pageResult.loading || done || !pageResult.data) {
			return;
		}

		const data = get(pageResult.data, dataSelector);

		// Most commonly the totalCount of records consumed by the server
		const serverCount = get(pageResult.data, totalCountSelector);

		if (!serverCount) {
			throw new Error("TotalCount selector could not find the query count property");
		}

		if (!data) {
			throw new Error("Data selector could not find the query data property");
		}

		const newOffset = offset + pageSize;

		// if there are entries we haven't consumed yet...
		if (newOffset > aggregation.length) {
			// consume them
			setAggregation(aggregation.concat(data));

			// and check for more
			if (newOffset < Math.min(serverCount, limit)) {
				setOffset(newOffset);
			}
		}

		// Offset now matches serverCount and we are done
		if (newOffset >= Math.min(serverCount, limit)) {
			setDone(true);
		}
	},
	[
		pageResult,
		pageSize,
		aggregation,
		offset,
		setOffset,
		dataSelector,
		totalCountSelector,
		limit,
		done,
	]);

	return children({
		data: aggregation,
		done,
	});
};
export default Unpaginate;
